import $ from 'jquery';
import scrollTo from 'jquery.scrollto';

const review = {
    bindRatingStars() {
        $('.js-writeReviewStars .icon').click(function () {
            let rating = $(this).attr('data-rating');
            $('.js-ratingSetInput').val(rating);
            $('.js-writeReviewStars .icon').each(function( index) {
                if(index+1 <= rating) {
                    $(this).children(0).attr('xlink:href', '#icon-star-full');
                }
                else {
                    $(this).children(0).attr('xlink:href', '#icon-star');
                }
            });
        });
    },
    setRatingStars() {
        let rating = $('input[name="rating"]').val();
        $('.js-writeReviewStars .icon').each(function( index) {
            if(index+1 <= rating) {
                $(this).children(0).attr('xlink:href', '#icon-star-full');
            }
            else {
                $(this).children(0).attr('xlink:href', '#icon-star');
            }
        });
    },
    bindProductPriceCellRatingStars() {
        $('.js-price-cell-rating-stars').click(function () {
            $('.c-tab__head__item--active').removeClass('c-tab__head__item--active');
            $('.c-tab__body--active').removeClass('c-tab__body--active');
            $('.c-tab__head__item[data-href="reviewTabBody"]').addClass('c-tab__head__item--active');
            $('#reviewTabBody').addClass('c-tab__body--active');
            var offset = $('.c-tabs__wrapper').offset().top - $('#header-sticky-placeholder').height();
            $('body').scrollTo(offset, 'slow');
        });
    }
};

// DOM ready
$(() => {
    review.bindRatingStars();
    review.setRatingStars();
    review.bindProductPriceCellRatingStars();
});

export default review;
